import { __makeTemplateObject } from "tslib";
import { styled } from '../../../foundation';
export var menuListBoundaryPadding = 8;
export var StyledMenuListPadding = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n"], ["\n  height: ", "px;\n"])), function (_a) {
    var _b = _a.height, height = _b === void 0 ? menuListBoundaryPadding : _b;
    return height;
});
var templateObject_1;
